import { render, staticRenderFns } from "./myBalance.vue?vue&type=template&id=8aeaedf2&scoped=true&"
import script from "./myBalance.vue?vue&type=script&lang=js&"
export * from "./myBalance.vue?vue&type=script&lang=js&"
import style0 from "./myBalance.vue?vue&type=style&index=0&id=8aeaedf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeaedf2",
  null
  
)

export default component.exports